module.exports = require('lodash').isNaN